var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.39 9.74L23 7.86V2C23 1.46957 22.7893 0.960859 22.4142 0.585786C22.0391 0.210714 21.5304 0 21 0L7 0C6.46957 0 5.96086 0.210714 5.58579 0.585786C5.21071 0.960859 5 1.46957 5 2V7.86L0.61 9.74C0.429252 9.81655 0.275031 9.94461 0.166558 10.1082C0.058086 10.2718 0.000159977 10.4637 0 10.66L0 22C0 22.5304 0.210714 23.0391 0.585786 23.4142C0.960859 23.7893 1.46957 24 2 24H26C26.5304 24 27.0391 23.7893 27.4142 23.4142C27.7893 23.0391 28 22.5304 28 22V10.66C27.9998 10.4637 27.9419 10.2718 27.8334 10.1082C27.725 9.94461 27.5707 9.81655 27.39 9.74ZM26.91 10.62L23 12.86V9L26.91 10.62ZM6 2C6 1.73478 6.10536 1.48043 6.29289 1.29289C6.48043 1.10536 6.73478 1 7 1H21C21.2652 1 21.5196 1.10536 21.7071 1.29289C21.8946 1.48043 22 1.73478 22 2V13.43L14 18L6 13.43V2ZM5 9V12.91L1.09 10.62L5 9ZM27 22C27 22.2652 26.8946 22.5196 26.7071 22.7071C26.5196 22.8946 26.2652 23 26 23H2C1.73478 23 1.48043 22.8946 1.29289 22.7071C1.10536 22.5196 1 22.2652 1 22V11.72L13.5 18.87C13.652 18.9578 13.8245 19.004 14 19.004C14.1755 19.004 14.348 18.9578 14.5 18.87L27 11.72V22Z",
    fill: "#6F6F6F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.31b29af6c8f5b3acc1d0f919ef1d644d.svg";
export { ForwardRef as ReactComponent };